import { Spinner } from '@concord/ui';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router';

/**
 * Signed in, on the way back to the user guide: the API checks the session and sends the
 * navigator to docs.cancerexpert.now with a one-minute signed pass.
 */
export function DocsHandoff() {
  const [params] = useSearchParams();
  const ret = params.get('return') ?? '/';
  useEffect(() => {
    window.location.replace(`/api/docs/handoff?return=${encodeURIComponent(ret)}`);
  }, [ret]);
  return (
    <div style={{ display: 'grid', placeItems: 'center', minHeight: '60vh' }}>
      <Spinner label="Opening the user guide…" />
    </div>
  );
}
